import { useRef, useEffect } from "react";

const createScrollStopListener = (element, callback, timeout = 200) => {
  let removed = false;
  let handle = null;
  const onScroll = () => {
    if (handle) {
      clearTimeout(handle);
    }
    handle = setTimeout(callback, timeout); // default 200 ms
  };
  element.addEventListener("scroll", onScroll);
  return () => {
    if (removed) {
      return;
    }
    removed = true;
    if (handle) {
      clearTimeout(handle);
    }
    element.removeEventListener("scroll", onScroll);
  };
};

// Hook que inserta un event listener que detecta el final de un scroll, de esta manera no ejecutará multiples veces una misma función como podría pasar al usar useEventListener("scroll").

// PARAMETROS:
// callback: Función que se va a ejecutar en el último scroll
// domElement: El elemento del dom al que se insertará el listener, por defecto el 'window'

const useScrollEndListener = (callback, domElement = window, timeout) => {
  const callbackRef = useRef();
  callbackRef.current = callback;
  useEffect(() => {
    const destroyListener = createScrollStopListener(domElement, () => {
      if (callbackRef.current) {
        callbackRef.current();
      }
    });
    return () => destroyListener();
  }, [domElement]);
};

export default useScrollEndListener;
